module.exports = __webpack_public_path__ + "img/capability-slider-img_3.af31115.jpg";